import intersection from "lodash/intersection";

export function isArrayContainedIn(array, possibleContainer) {
  return intersection(array, possibleContainer).length === array.length;
}

export function arrayStringEquals(arrayA, arrayB, ignoreOrder = false) {
  if (ignoreOrder) {
    arrayA = [...arrayA].sort();
    arrayB = [...arrayB].sort();
  }
  return arrayA.toString() === arrayB.toString();
}

export function arrayStringContains(array, item) {
  return !!array.find(_item => arrayStringEquals(item, _item));
}
